import { languagesDataSource } from 'infrastructure/data-sources/languages';
import { debounce } from 'lodash';
import { useMemo } from 'react';

import { usePotentialPatientsFilter } from './use-potential-patients-count-filter';

import type { TPotentialPatientsCountFilter } from 'infrastructure/hooks/patient/use-get-potential-transfer-count';

const all = { label: 'All', value: 'all' };

export const useFilter = () => {
  const { filter, updateFilter, resetFilter, count } =
    usePotentialPatientsFilter();

  const debouncedUpdateFilter = useMemo(
    () =>
      debounce((filters: Partial<TPotentialPatientsCountFilter>) => {
        updateFilter(filters);
      }, 800),
    [updateFilter],
  );

  const languages = languagesDataSource().filter(
    (l) => l.id === 'en' || l.id === 'es',
  );
  const tempLang = languages.map((l) => ({
    value: l.id,
    label: l.name,
  }));
  const languageOptions = [all, ...tempLang];

  const clearModalFilter = () =>
    updateFilter({
      fromName: undefined,
      toName: undefined,
      fromAgencyDoctorGuid: undefined,
      toAgencyDoctorGuid: undefined,
      language: undefined,
      ccm: undefined,
      pcm: undefined,
      newlyEnrolledOnly: undefined,
      partialsOnly: undefined,
      followUpOnly: undefined,
      patientsCountToTransfer: undefined,
      selectedPatientsCount: undefined,
      clinicGuid: undefined,
      parentClinicGuid: undefined,
    });

  return {
    filter,
    updateFilter,
    count,
    resetFilter,
    languageOptions,
    clearModalFilter,
    debouncedUpdateFilter,
  };
};
